import { render, staticRenderFns } from "./blm.vue?vue&type=template&id=244efe48&scoped=true"
import script from "./blm.vue?vue&type=script&lang=ts"
export * from "./blm.vue?vue&type=script&lang=ts"
import style0 from "./blm.vue?vue&type=style&index=0&id=244efe48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244efe48",
  null
  
)

export default component.exports